import 'styles/extensions/img-slider.scss';

import { ImageSlider } from 'Components/Elements/ImageSlider';
import VideoIframe from 'Components/Elements/VideoIframe';
import PropUpPage from 'Components/PopUpPage';
import { IProduct } from 'core/redux/features/products/types';
import { LocationUtil } from 'core/utils/location';
import {
  addEventListener,
  hasClass,
  querySelectorAll,
  removeEventListener,
} from 'dom-helpers';
import React, { useEffect, useState } from 'react';
import { Portal } from 'react-portal';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import Swiper from 'swiper';
import { ReactComponent as GalleriIcon } from '../../../../assets/images/iconsv2/galleri.svg';
import { selectActiveProductInfo } from '../../../../core/redux/features/products/reducers/productInfos';
import { useHandleBackButton, useSelectViewModes } from '../../hooks';

// const _galleryContentCache = {};
const makeGalleryContent = (product?: Record<string, any>) => {
  let gallerySliderContent = [];

  if (!product) {
    return gallerySliderContent;
  }

  if (product.youtube_video && product.youtube_video.startsWith('http')) {
    gallerySliderContent.push(
      <div key={product.youtube_video} className="img-slider__img">
        <div style={{ maxWidth: '750px', margin: '0 auto' }}>
          <VideoIframe src={product.youtube_video} />
        </div>
      </div>,
    );
  }

  if (product?.images && product.images.length > 0) {
    product.images.forEach((m, i) => {
      gallerySliderContent.push(
        <div key={i} className="img-slider__img">
          <img src={m.url} alt={m.alt} />
        </div>,
      );
    });
  }

  return gallerySliderContent;
};

// const getGalleryContent = (product: Record<string, any>) => {
//   if (!product?.id) {
//     return [];
//   }
//
//   let contents = _galleryContentCache[product?.id];
//   if (!contents) {
//     _galleryContentCache[product?.id] = contents = makeGalleryContent(product);
//   }
//
//   return contents;
// };

function Gallery() {
  const { viewMode } = useSelectViewModes();
  // const product = useSelector(selectActiveProduct);
  const productInfo = useSelector(selectActiveProductInfo);
  const handleBackButton = useHandleBackButton('gallery');
  const [swiper, setSwiper] = useState<Swiper>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (viewMode.id !== 'gallery') {
      return;
    }

    const find = querySelectorAll(
      document.body,
      '.product-display.product-preview',
    );

    if (find.length > 0) {
      find[0].scrollIntoView({ behavior: 'auto' });
    }
  }, [viewMode, swiper]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!document.body || !swiper) {
      return;
    }

    const handleKeypress = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleBackButton();
      }
    };

    addEventListener(document.body, 'keydown', handleKeypress);
    return () => {
      removeEventListener(document.body, 'keydown', handleKeypress);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swiper]);

  if (viewMode.id !== 'gallery') {
    return null;
  }

  const gallerySliderContent = makeGalleryContent(productInfo);

  return (
    <Portal node={document.body}>
      <PropUpPage
        force={true}
        style={{ margin: 0 }}
        data-testid="productGallery"
        className="m-galleri pop-page--gallery"
        scrollableContent={true}
        backdrop={true}
        onClick={e => {
          if (hasClass(e.target as HTMLElement, 'img-slider__img')) {
            handleBackButton();
          }
        }}
      >
        <div
          className="m-head__nav m-head__nav--close"
          onClick={handleBackButton}
        >
          <div className="eb-circle img-slider__close">
            <span className="eb eb-close" />
          </div>
        </div>

        {productInfo &&
          gallerySliderContent &&
          gallerySliderContent?.length > 0 && (
            <div className="info-view-galleri">
              <div className="img-slider">
                <div className="img-slider__wrap">
                  <ImageSlider
                    onSetSlider={setSwiper}
                    slides={gallerySliderContent}
                  />
                </div>
              </div>
            </div>
          )}
      </PropUpPage>
    </Portal>
  );
}

export function ViewGalleryOverlay({ product }: { product: IProduct }) {
  const history = useHistory();
  const location = useLocation();
  return (
    <div
      className="galleri-block"
      onClick={e => {
        e.preventDefault();
        const loc = new LocationUtil(location);
        loc.setHash('galleri');
        history.push(loc.toString());
      }}
    >
      <GalleriIcon />
      <span>{product?.images?.length}</span>
    </div>
  );
}

export default Gallery;
